// just return all state
export const getAllstate = state => state

// loading state
export const getLoading = state => state.loading

// Language
export const getLanguage = state => state.lang

// User
export const getUser = state => {
  return state.user
}

// count state
export const getCount = state => state.loadCount

// count state
export const getAppId = state => state.appId

// count state
export const getPageId = state => state.pageId



// WEBPACK FOOTER //
// ./src/store/getters.js